import React from 'react';
import { EditorClientConnector } from '../editor/EditorClientConnector';
import { EditorNotificationsEditorAndGame } from '../editor/EditorNotifications';
import { EditorGame } from './EditorGame';
import { EditorPopupWindows } from '../editor/EditorPopupWindows';
import { MenuCard } from '../menu/MenuCard';
import { Adjustment, SlideMenu, State } from '../menu/SlideMenu';
import { SettingsMenu } from '../editor/SettingsMenu';
export const Game = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditorClientConnector, null), /*#__PURE__*/React.createElement(EditorPopupWindows, null), /*#__PURE__*/React.createElement(EditorNotificationsEditorAndGame, null), /*#__PURE__*/React.createElement(SlideMenu, {
    identifier: "settings",
    orientation: Adjustment.Right,
    start: 0,
    state: State.Expanded,
    collapsible: false
  }, /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(SettingsMenu, {
    showNonGameSettings: false
  }))), /*#__PURE__*/React.createElement(EditorGame, null));
};